export default "__VITE_ASSET__CYALPzUn__"